import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Font loading to prevent flickering
const font = new FontFace('Extenda 30 Deca', 'url(../public/Extenda 30 Deca.woff)');

font.load().then(() => {
  document.fonts.add(font);
  document.documentElement.classList.add('wf-loaded');
}).catch(() => {
  // Fallback if font fails to load
  document.documentElement.classList.add('wf-loaded');
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
